import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#ffffff',
    className: null,
};

const FooterBottomLine = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="480px"
        height="5.5px"
        viewBox="0 0 480 5.5"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <g>
                <path
                    fill={color}
                    d="M474.8,0.2c-0.5,0-1.2-0.1-1.3-0.1c-1,0.1-1.2,0-1.4-0.1c-0.6-0.2-2.4,0-3.5-0.1c-1.5,0.3-3,0-4.5,0.1
    			c-0.9,0-2.1,0.1-2.8,0.1c-2.2-0.1-4.6,0-6.8,0c-1.5,0-2.2,0-3.2-0.1c-0.4,0.1-0.6,0.2-0.9,0.4c-2.7-0.3-5.6-0.2-8.7-0.1
    			c-0.6-0.1-1.1-0.1-1.7-0.2c-0.6,0.1-1.1,0.1-1.6,0.1c-0.5,0-1,0.1-1.9,0.1c-0.3-0.1-0.6-0.1-0.6-0.1c-1.9,0.1-3.5,0.2-4.7,0.1
    			c-2.5-0.1-4.7,0-7.1,0.1c-2.4,0.1-5.2,0.2-6.8,0c-1.1,0-2,0.1-2.9,0.1c-0.9,0-1.8,0-2.8-0.1c-0.6,0.1-1.5,0.2-3.1,0.2
    			c-1,0-2-0.1-3-0.1c-1.5,0-3,0-3.5,0.2c-1.3-0.1-2.3-0.1-3.5-0.2c-0.8,0.1-1.3,0.2-2.2,0.3c-0.4-0.1-0.6-0.2-0.8-0.2
    			c-1.4,0-2.8,0-2.6,0.2c-1,0-1.9,0-2.8,0c-0.7,0-1.5,0.1-2,0c-1.7,0-3.3-0.1-5.1,0c-0.1,0-0.5,0-0.7,0c-1.2-0.1-2.6,0-3.9,0
    			c-0.6,0-1.2-0.1-1.8-0.1c-2.1,0.1-2.1,0.1-6.7,0.1C370.1,1,370,1,369.9,1.1C366.5,1,363.3,1,360,1.1c-2.4-0.1-5.4,0.2-7.1,0
    			c-1.3,0.1-2.2,0.1-3.1,0.1c-0.6-0.1-1.1-0.1-1.8-0.2c-0.5,0.1-0.9,0.2-1,0.2c-1.9,0-3.4,0-4.7,0c-1.6,0-3.1,0.1-4.5,0
    			c-0.4,0-1,0-1.6-0.1c-0.2,0.1-0.3,0.1-0.5,0.3c-1.7,0-3.2-0.1-4.7-0.1c-0.2,0-0.4,0-0.6,0c-0.8,0.1-1.6,0.1-2.5,0.2
    			c-0.2,0-0.6-0.1-0.9-0.1c-1.1,0-2,0.1-2.9,0.1c-0.7,0-1.3-0.1-1.7-0.1c-1.2,0.1-2.3,0.2-3.3,0.2c-4.1,0-8.3,0.1-12.4,0
    			c-0.5,0-1.4,0-1.7,0c-2.6,0.2-5.5,0-8.2,0.1c-2-0.2-3.1,0-4.4,0.1c-1.6-0.2-3.2-0.2-5.2-0.1c-0.3,0-1,0-1.3,0
    			c-2.2-0.1-3.7,0.1-5.2,0.2c-0.4-0.1-0.8-0.2-0.9-0.2c-2.5,0.1-4.9,0-7.3,0c-3.1,0-6.1,0.2-9.3,0.1c-1.9,0.1-3.6,0-5.3,0
    			c-0.6,0-1.7,0-1.9,0c-1.7,0.3-3,0.1-4.4,0c-2.8,0.2-3.2,0.2-3.5-0.1c-0.8,0.1-1.4,0.2-2.2,0.3c-1.8-0.2-4.6,0.1-6.5-0.1
    			c-0.4,0.1-0.8,0.2-1.3,0.3c-1.5-0.1-2.7-0.2-4.1-0.3c-2.3,0.2-4.8,0-7.2,0.1c0,0,0,0.1,0,0.1c-2.2,0.1-3.9,0-5.1-0.2
    			c-1.4,0.1-2.2,0.3-4,0.2c-2.3-0.1-2.5,0.1-3.5,0.2c-1.2-0.1-2-0.3-4.1-0.1c-0.6-0.1-1.2-0.2-1.7-0.2c-1.3,0.1-2.1,0.1-3,0.2
    			c-0.4-0.1-0.7-0.1-0.9-0.1c-1.2,0.1-2.4,0.1-3.6,0.2c-0.4-0.1-0.8-0.1-1.3-0.2c-0.7,0.1-1.3,0.2-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.2
    			c-2.2,0.2-4.4,0.3-6.3,0.2c-2.9-0.1-5.5,0-7.9,0.1c-1.3,0-2.5,0-3.5,0c-1.5-0.1-1.9,0.2-3.2,0.1c-0.6-0.1-1.2-0.1-1.8-0.2
    			c-1.1,0.1-2.1,0.2-3.1,0.3c-1.4-0.1-2.8-0.1-4.2-0.2c-0.5,0.1-0.9,0.1-1.3,0.2c-0.7,0-1.4,0-2,0c-0.8,0-1.7,0-2.5,0
    			c-1.6,0-3.3-0.1-4.5,0.1C154.4,3,152,3.2,150.2,3c-0.7-0.1-1.6-0.1-1.9,0c-0.4,0.1-1,0.1-1.9,0.1c-0.5,0-1,0.1-1.5,0.1
    			c-0.4,0-0.7,0-1.1-0.1c-0.4,0-0.7-0.1-0.8-0.1c-0.6,0-1.2,0.1-1.7,0.1c-1.3,0-2.5,0-3.7-0.1c-2.1,0-3,0.1-3.9,0.3
    			c-0.1,0-0.5,0-0.9,0c0.1-0.1,0.1-0.2,0.2-0.3c-1.1,0-1.9,0.1-2.6,0.1c-0.6,0-1.5,0.1-1.8,0c-0.5,0-0.7-0.1-1.2-0.2
    			c-1.1,0.1-2.1,0.2-3.3,0.3c-1,0-2.3,0-3.5,0c-2.9-0.1-2.9-0.1-4.5,0.2c-1-0.2-2.9-0.2-4.3-0.1c-1.3,0.1-2.4,0.1-3.6,0.1
    			c-1.6,0-3.2,0-4.7,0.1c-1,0.1-1.9,0-2.8,0c-1.6-0.1-2.3,0-2.7,0.1c-3.2,0.1-5.7-0.1-8.8-0.1c0.3,0.1,0.5,0.1,0.7,0.2
    			c-2.5,0.1-3.7,0-4.5-0.2c-1.5,0.1-2,0.1-4.1,0.1c-0.3,0-0.7,0-0.9,0c-1.3,0.2-2.4,0.1-3.7,0c-0.6,0-2.2,0-2.2,0
    			c-0.4,0.2-2.1,0.1-2.4,0.1c-1.4,0.2-2.2,0-3.5,0c-1.2,0-2.4,0.1-3.9,0c-0.8-0.1-2.9,0-4.3,0.1c-1.9,0.1-3.1,0-4.7-0.1
    			C55.3,3.9,55,4,54.6,4c-1.1-0.1-2-0.1-3-0.2c-1.2,0.3-3.1,0.3-5.1,0.2c-0.8,0-1.7,0-2.9-0.1c0.3,0.1,0.5,0.1,0.9,0.2
    			c-1.5,0-3.1,0-3.7,0c-1.6-0.2-2.6-0.1-4.5,0c-1.5,0.1-3.8,0.1-5.7,0.1c-0.9,0-1.8-0.1-2.8-0.2c-1.7,0.2-3,0.3-4.3,0.2
    			c-2.1-0.1-6.1,0-7.9,0c-1.5,0.1-2.6,0-3-0.1c-0.1,0-0.4,0-0.9-0.1c0,0.1,0,0.1,0,0.2c-2.6,0-5,0-6.7,0C3.9,4.5,3,4.6,2.3,4.6
    			C1.4,4.7,0.2,4.8,0,4.9l2.9,0.1c1.7,0,4.3,0,6.9,0c0-0.1,0-0.1,0-0.2c0.5,0,0.9,0,0.9,0.1c0.4,0.2,1.6,0.2,3.1,0.1
    			c0.8,0,2-0.1,3.3-0.1c0.2,0,0.4,0,0.7,0c0,0,0,0,0,0c1.6,0,3.2,0,4.2,0c1.3,0,2.7,0,4.5-0.2c1,0.1,1.9,0.2,2.9,0.2
    			c2,0,4.3,0,5.9-0.1c1.9-0.1,3-0.2,4.6,0c0.6,0.1,2.2,0,3.8,0c-0.4-0.1-0.6-0.1-0.9-0.2c1.2,0,2.1,0,3,0.1c2.1,0.1,4.1,0.1,5.3-0.2
    			c0.2,0,0.3,0,0.5,0c0,0,0,0,0,0c0,0,0.3,0,0.8-0.1c0.1,0.1,0.3,0.1,0.2,0.1c0,0-0.1,0-0.1,0c0.6,0,1.1,0.1,1.8,0.1
    			c0.4-0.1,0.7-0.1,1.1-0.2c1.7,0.1,3,0.2,4.9,0.1c1.4-0.1,3.6-0.1,4.4-0.1c1.6,0.1,2.9,0,4.1,0c1.3-0.1,2.1,0.2,3.6,0
    			c0.3,0,2,0,2.4-0.1c0,0,0.3,0,0.7,0c-0.2,0-0.4-0.1-0.4-0.1c0,0,0.3,0,0.5-0.1c0.2,0,0.5,0,0.5,0.1c0,0-0.2,0-0.4,0.1
    			c0.5,0,1.1,0,1.4,0c1.3,0.1,2.5,0.1,3.8,0c0.1,0,0.6,0,0.9,0c2.2,0,2.7,0,4.3-0.1c0.8,0.2,2.1,0.3,4.7,0.2
    			c-0.2-0.1-0.4-0.1-0.7-0.2c3.3,0,5.8,0.3,9.1,0.1c0.4-0.2,1.2-0.2,2.8-0.1c1,0,1.8,0.1,2.9,0c1.6-0.1,3.3-0.1,4.9-0.1
    			c1.2,0,2.4,0,3.7-0.1c1.5-0.1,3.4-0.1,4.4,0.1c1.7-0.2,1.7-0.2,4.6-0.2c1.2,0,2.6,0,3.6,0c1.2-0.1,2.2-0.2,3.4-0.3
    			c0.5,0.1,0.7,0.2,1.2,0.2c0.3,0,1.2,0,1.9,0c0.8,0,1.5-0.1,2.7-0.1c-0.1,0.1-0.1,0.2-0.2,0.4c0.5,0,0.9,0,1-0.1
    			c0.9-0.2,1.8-0.3,4-0.3c1.3,0,2.5,0,3.8,0.1c0.5,0,1.1,0,1.8-0.1c0.1,0,0.5,0.1,0.9,0.1c0.3,0,0.7,0.1,1.1,0.1
    			c0.5,0,1-0.1,1.5-0.1c0.9,0,1.6,0,2-0.1c0.4-0.1,1.3-0.1,2,0c1.8,0.2,4.3,0,6.1,0.1c1.2-0.2,3-0.1,4.7-0.1c0.8,0,1.7,0,2.5,0
    			c0.7,0,1.4,0,2.1,0c0.4-0.1,0.8-0.1,1.4-0.2c1.5,0.1,2.9,0.1,4.3,0.2c1-0.1,2-0.2,3.2-0.3c0.6,0.1,1.3,0.1,1.9,0.2
    			c1.4,0.1,1.8-0.2,3.3-0.1c1,0,2.3,0,3.6,0c2.5-0.1,5.2-0.2,8.2-0.1c2,0.1,4.3,0,6.5-0.2c0.4,0.1,0.8,0.2,1.2,0.2
    			c1.1-0.1,1.7-0.2,2.4-0.3c0.5,0.1,0.9,0.1,1.3,0.2c1.3-0.1,2.5-0.1,3.8-0.2c0.2,0,0.5,0.1,0.9,0.1c0.9-0.1,1.7-0.1,3.1-0.2
    			c0.5,0.1,1,0.1,1.7,0.2c0,0,0.1,0,0.1,0c-0.4-0.1-0.2-0.2,0.2-0.3c0.3,0.1,0.5,0.1,0.8,0.2c1.4-0.1,2.2,0.1,3.2,0.2
    			c1-0.1,1.3-0.3,3.7-0.2c1.8,0.1,2.7-0.1,4.1-0.2c1.3,0.2,3,0.2,5.3,0.2c0-0.1,0-0.1,0-0.1c2.5-0.1,5.1,0.1,7.5-0.1
    			c1.4,0.1,2.7,0.2,4.2,0.3c0.4-0.1,0.9-0.2,1.3-0.3c2,0.2,4.9-0.1,6.7,0.1c0.8-0.1,1.4-0.2,2.3-0.4c0.3,0.3,0.7,0.3,3.6,0.1
    			c1.5,0.1,2.9,0.3,4.6,0c0.1,0,1.3,0,2,0c1.4,0,2.8,0.1,4.3,0.1c0.3,0,0.5,0,0.8,0c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0
    			c3.3,0.1,6.4-0.1,9.6-0.1c2.5,0,4.9,0.1,7.5,0c0.1,0,0.5,0.1,1,0.2c1.5-0.2,3.1-0.3,5.3-0.2c0.4,0,1.1,0,1.4,0
    			c2.1-0.2,3.8-0.1,5.4,0.1c1.4-0.1,2.5-0.4,4.6-0.1c2.8-0.1,5.7,0.1,8.4-0.1c0.3,0,1.2,0,1.7,0c4.2,0.1,8.6,0,12.9,0
    			c1,0,2.1-0.1,3.4-0.2c0.4,0,1,0.1,1.7,0.1c0.9,0,1.8-0.1,3-0.1c0.3,0.1,0.7,0.1,0.9,0.1c0.9-0.1,1.7-0.2,2.5-0.2
    			c0.2,0,0.5,0,0.6,0c1.6,0,3.1,0.1,4.8,0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.6,0,1.2,0,1.7,0.1c1.5,0.1,3,0.1,4.6,0c1.4,0,3,0,4.9,0
    			c0.1,0,0.5-0.1,1-0.2c0.7,0.1,1.3,0.1,1.9,0.2c0.4,0,0.9,0,1.3-0.1c-0.2,0-0.4,0-0.6-0.1c0.7,0,1.2,0,1.7,0c0.2,0,0.5,0,0.8,0
    			c0.1,0,0.2,0,0.3,0c-0.5-0.1,0.1-0.2,1.4-0.2c0.1,0.1,0.2,0.2,0.3,0.3c-0.7,0-1.2,0-1.7,0c1.8,0.2,4.6-0.1,7,0
    			c3.4-0.2,6.8-0.1,10.2-0.1c0.1-0.1,0.2-0.1,0.2-0.2c4.7,0.1,4.7,0.1,6.9-0.1c0.6,0,1.2,0.1,1.9,0.1c1.3,0,2.8-0.1,4.1,0
    			c0.2,0,0.6,0,0.7,0c1.8-0.2,3.5-0.1,5.3,0c0.6,0,1.4,0,2.1,0c0.9,0,1.9,0,2.9,0c-0.2-0.2,1.2-0.2,2.7-0.2c0.2,0.1,0.5,0.1,0.8,0.2
    			c0.9-0.1,1.4-0.2,2.2-0.3c1.2,0.1,2.3,0.1,3.6,0.2c0.5-0.2,2.1-0.2,3.7-0.2c1.1,0,2.1,0.1,3.1,0.1c1.6,0,2.6,0,3.2-0.2
    			c1,0,1.9,0.1,2.9,0.1c0.9,0,1.8-0.1,3-0.1c1.7,0.2,4.5,0.1,7,0c2.5-0.1,4.8-0.1,7.4-0.1c1.2,0,2.9-0.1,4.8-0.1
    			c0,0,0.3,0.1,0.6,0.1c1-0.1,1.5-0.1,2-0.1c0.5,0,1-0.1,1.7-0.1c0.6,0.1,1.1,0.1,1.7,0.2c3.2-0.2,6.3-0.2,9,0.1
    			c0.4-0.1,0.6-0.2,1-0.4c1,0.1,1.7,0.2,3.3,0.1c2.3-0.1,4.7-0.1,7,0c0.7,0,1.9-0.1,2.9-0.1c0.6,0,1.2,0,1.7,0c0,0,0-0.1-0.1-0.1
    			c-0.2-0.2-0.7-0.3-2.4-0.3c-0.6,0-1.1-0.1-1.7-0.1C475.6,0.2,475,0.2,474.8,0.2z M19.2,4.8c-1.5,0.1-2.2,0-1.8-0.2
    			C18.3,4.7,18.7,4.8,19.2,4.8z M27.9,4.5c-0.2,0-0.5,0-0.8,0c0.2,0,0.4,0,0.6-0.1c0.4,0,0.6,0,0.9,0.1C28.3,4.4,28.1,4.5,27.9,4.5z
    			 M39.4,4.6c0,0-0.4,0-0.6,0c-0.1,0-0.1-0.1-0.2-0.1c0.3,0,0.6,0,0.8,0C39.5,4.5,39.5,4.6,39.4,4.6z M47.7,4.5
    			c-0.5-0.2-0.5-0.2,1.4-0.2C48.6,4.4,48.2,4.4,47.7,4.5z M80.3,4.4c0,0-0.4,0-0.6,0.1c-0.1,0-0.4-0.1-0.3-0.1c0,0,0.3,0,0.7-0.1
    			C80.1,4.3,80.3,4.4,80.3,4.4z M84.6,3.9c-0.3,0-0.6,0-0.9-0.1c0.2,0,0.5,0,0.9-0.1c0.3,0,0.5,0.1,0.8,0.1
    			C85,3.9,84.7,3.9,84.6,3.9z M99.8,4.1c-0.3,0-0.5,0.1-0.6,0.1c-0.2,0-0.5,0-0.6-0.1c0,0,0.3-0.1,0.4-0.1C99.2,4,99.4,4.1,99.8,4.1
    			z M215.7,2.9c-1.3,0.1-1.6,0-1.4-0.2C215,2.8,215.3,2.9,215.7,2.9z M275.4,2.3c0.5-0.1,1.1-0.2,2.7-0.2
    			C277.4,2.2,277.2,2.3,275.4,2.3z"
                />
                <path
                    fill={color}
                    d="M220.9,3.6c-0.3,0-0.7-0.1-1.4-0.2C219.2,3.6,219.5,3.6,220.9,3.6z"
                />
                <path
                    fill={color}
                    d="M282.8,2.9c1.8,0.1,2.1-0.1,2.8-0.2C283.9,2.7,283.3,2.8,282.8,2.9z"
                />
                <path
                    fill={color}
                    d="M51.1,5.3c0.3,0,0.7,0,0.7,0c0,0-0.1-0.1-0.2-0.1c-0.5,0.1-0.8,0.1-0.8,0.1C50.8,5.3,51,5.3,51.1,5.3z"
                />
                <path fill={color} d="M47,5.2c0.5-0.1,0.9-0.1,1.5-0.2C46.5,5,46.5,5,47,5.2z" />
                <path
                    fill={color}
                    d="M37.7,5.3c0.2,0,0.6,0,0.6,0c0.1,0,0.1-0.1,0.1-0.1c-0.3,0-0.6,0-0.9,0C37.6,5.2,37.7,5.3,37.7,5.3z"
                />
                <path
                    fill={color}
                    d="M25.6,5.1c0.3,0,0.6,0,0.8,0c0.3,0,0.5,0,0.7-0.1c-0.3,0-0.5,0-0.9-0.1C26,5.1,25.8,5.1,25.6,5.1z"
                />
                <path
                    fill={color}
                    d="M84.2,4.5c0.3,0,0.6,0.1,0.9,0.1c0.2,0,0.5,0,0.8-0.1c-0.2,0-0.5-0.1-0.8-0.1C84.7,4.5,84.4,4.5,84.2,4.5z"
                />
                <path
                    fill={color}
                    d="M99.6,4.8c0,0,0.4,0,0.6,0.1c0.2,0,0.4-0.1,0.7-0.1c-0.3,0-0.6,0-0.8-0.1C99.9,4.7,99.6,4.8,99.6,4.8z"
                />
                <path
                    fill={color}
                    d="M116.6,5.1c0,0,0.4,0,0.7,0c0.3,0,0.7,0,0.7-0.1c0,0-0.2-0.1-0.7-0.2C116.9,5,116.6,5.1,116.6,5.1z"
                />
                <path
                    fill={color}
                    d="M80,5.1c0.2,0,0.6,0,0.7-0.1c0.1,0-0.2-0.1-0.4-0.1C80,5,79.7,5,79.6,5.1C79.6,5.1,79.9,5.1,80,5.1z"
                />
                <path
                    fill={color}
                    d="M76.3,5c0,0-0.4,0-0.5-0.1C75.5,5,75.2,5,75.2,5c0,0,0.3,0.1,0.5,0.1C76,5.1,76.3,5,76.3,5z"
                />
                <path
                    fill={color}
                    d="M84.1,5.5c0.2,0,0.5,0,0.7-0.1c-0.3,0-0.5,0-0.9-0.1c-0.2,0-0.4,0.1-0.6,0.1C83.6,5.4,83.8,5.5,84.1,5.5z"
                />
            </g>
        </g>
    </svg>
);

FooterBottomLine.propTypes = propTypes;
FooterBottomLine.defaultProps = defaultProps;

export default FooterBottomLine;
